<template>
  <div class="login">
    <div class="title">
      {{ $l.userRegister }}
    </div>

    <input-email class="email" />
    <input-password class="password" />
    <input-name class="name"/>
    <input-tel class="tel" />
    <input-birth-day class="birth-day" />
    <input-country class="country" />
    <input-prefecture class="prefecture" />
    <input-address class="address" />
    <div class="tos">
      <check-tos class="tos-check" />
      <link-tos class="tos-link" />
    </div>

    <error-message :errorMessage="errorMessage" />

    <button-white
      class="button-register"
      size="full"
      :disabled="$store.getters['user/isBlank'] || $store.getters['register/notAgreed']"
      :title="$l.register"
      :action="register"
      />

    <link-login class="link-login" />
  </div>
</template>

<script>
import ButtonWhite from '@/components/ButtonWhite'
import MixinLocale from '@/components/MixinLocale'
import InputEmail from '@/components/Register/Email'
import InputPassword from '@/components/Register/Password'
import InputName from '@/components/Register/Name'
import InputTel from '@/components/Register/Tel'
import InputBirthDay from '@/components/Register/BirthDay'
import InputCountry from '@/components/Register/Country'
import InputPrefecture from '@/components/Register/Prefecture'
import InputAddress from '@/components/Register/Address'
import CheckTos from '@/components/Register/Tos'
import LinkTos from '@/components/Register/TosLink'

import LinkLogin from '@/components/Register/LinkLogin'

import ErrorMessage from '@/components/Error/Message'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    InputEmail,
    InputPassword,
    InputName,
    InputTel,
    InputBirthDay,
    InputCountry,
    InputPrefecture,
    InputAddress,
    CheckTos,
    LinkTos,
    LinkLogin,
    ButtonWhite,
    ErrorMessage
  },

  data () {
    return {
      username: '',
      password: '',
      errorMessage: null
    }
  },

  methods: {
    register: async function () {
      this.errorMessage = await this.$store.dispatch('user/signUp')
      if (!this.errorMessage) {
        this.$router.push({ name: 'home' })
      }
    },

    userNew: function () {
      this.$router.push({ name: 'register' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/components/Register/_input.scss';
.login {
  padding: 30px;
  background: #3498db;
}

.title {
  text-align: center;
  color: white;
  font-size: 1.6em;
}

.email {
  margin-top: 20px;
  margin-bottom: 10px;
}

.password {
  margin-bottom: 10px;
}

.name {
  margin-bottom: 10px;
}

.tel {
  margin-bottom: 10px;
}

.birth-day {
  margin-bottom: 10px;
}

.country {
  margin-bottom: 10px;
}

.prefecture {
  margin-bottom: 10px;
}

.address {
  margin-bottom: 30px;
}

.tos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;

  &:hover {
    cursor: pointer;
  }
}

.tos-check {
  margin-bottom: 10px;
}

.tos-link {
  margin-bottom: 30px;
}

.button-register {
  margin-bottom: 30px;
}
</style>
